// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3Ccqv","search":"Settings_search__1vsv2","filter":"Settings_filter__bAPC8"};